import { getEntityPrimaryKey } from "../../stateCommon/getEntityPrimaryKey";
import { getDebugParams, getGetDeleteParams, getObjectJSONString, getPickBodyCode } from "../utils/code";
import { defaultMethodConfig } from "../utils/consts";
import { getPostDataArgs, invokeAndLogDebugCode, selectConfig } from "./common";
import { FORM_INFOS } from "../formMethods/formInfos";
import { getCgiDefaultParamsValue } from "../../common/schemaUtil";
function getResponseProcess({
  options,
  isForm,
  succMsg
}) {
  const {
    cgi
  } = options;
  const {
    codeString,
    messageString
  } = options.getStringOfCodeMessage(cgi);
  const getEntityString = `body${options.getProtocolPath(cgi, 'ENTITY_DATA')}`;
  const content = isForm ? `    // 如果接口有返回数据就进行回写
  if(typeof ${getEntityString} === 'object'){
    source.formData = ${getEntityString};
  }` : `    // 如果接口有返回数据就进行回写
    if(typeof ${getEntityString} === 'object'){
      const index = source.listData.indexOf(postData);
      if(index >= 0){
        source.listData.splice(index,1,${getEntityString});
      }
    }`;
  return `
  // 处理接口的返回结果
  if (${codeString} === 0) {
    ${content}
    $tips.success({
      content: '${succMsg}'
    })
  } else {
    $tips.error({
      content: ${messageString}
    })
  }
  return body;
`;
}
const getCreateCode = options => {
  const {
    collection,
    stateModel,
    isHttp
  } = options;
  const isForm = ['form_JS', 'rv_form_JS'].includes(stateModel);
  // http create 保留用户的query参数
  const dataKey = isForm ? 'source.formData' : 'postData';
  let params = `    body: ${dataKey},
  ${getPickBodyCode(dataKey)}`;
  if (isHttp) {
    const {
      query
    } = getCgiDefaultParamsValue(collection, 'create');
    if (query && Object.keys(query).length) {
      params = `
    ${getObjectJSONString(query)},
${params}`;
    }
  }
  const code = `
async ( ${isForm ? '' : 'postData'} ) => {

  // 调用create接口
  const { body } = await source.$requests.create({
${params}
  });

${getResponseProcess({
    options,
    isForm,
    succMsg: '创建成功'
  })}
}
`;
  const config = {
    args: isForm ? [] : getPostDataArgs(),
    code
  };
  return config;
};
export function generateCreateMethod(options) {
  const isForm = ['form_JS', 'rv_form_JS'].includes(options.stateModel);
  const config = selectConfig(options, getCreateCode, isForm ? FORM_INFOS.form.create : FORM_INFOS.list.create);
  const res = {
    id: 'create',
    title: '创建',
    ...defaultMethodConfig,
    ...config,
    debugCode: invokeAndLogDebugCode
  };
  return res;
}
const getUpdateCode = options => {
  const {
    collection,
    stateModel,
    isHttp
  } = options;
  const isForm = ['form_JS', 'rv_form_JS'].includes(stateModel);
  // http 保留用户的query参数和模板的id，body都是要模板
  // db update是需要一个主键的，这里生成代码时通过实体 schema获取主键的key
  const key = getEntityPrimaryKey(collection);
  const formDataString = isForm ? 'source.formData' : 'postData';
  let httpQuery = '';
  if (isHttp) {
    const {
      query
    } = getDebugParams(collection, 'update') || {};
    if (query && Object.keys(query).length) {
      httpQuery = Object.entries(query).map(([key, val]) => `    ${key}: ${val}`).join('\n');
    }
  }
  const query = `    query:{
    // ${key ? '这里读取实体获取的主键' : '用户没有设置实体主键，这里默认使用 id'}
    id: ${formDataString}['${key || 'id'}'], ${httpQuery ? `\n${httpQuery}` : ''}
  },`;
  const body = `body: ${formDataString},
  ${getPickBodyCode(formDataString)}`;
  const code = `
  async ( ${isForm ? '' : 'postData'} ) => {

    // 调用update接口
    const { body } = await source.$requests.update({
${query}
${body}
    });

  ${getResponseProcess({
    options,
    isForm,
    succMsg: '更新成功'
  })}
  }
  `;
  return {
    args: getPostDataArgs(),
    code
  };
};
export function generateUpdateMethod(options) {
  const isForm = ['form_JS', 'rv_form_JS'].includes(options.stateModel);
  const config = selectConfig(options, getUpdateCode, isForm ? FORM_INFOS.form.update : FORM_INFOS.list.update);
  const res = {
    id: 'update',
    title: '更新',
    ...defaultMethodConfig,
    ...config,
    debugCode: invokeAndLogDebugCode
  };
  return res;
}
const getGetCode = options => {
  const {
    stateModel
  } = options;
  const isForm = ['form_JS', 'rv_form_JS'].includes(stateModel);
  const params = getGetDeleteParams(options);
  const {
    codeString,
    messageString
  } = options.getStringOfCodeMessage('get');
  const getEntityString = `body${options.getProtocolPath('get', 'ENTITY_DATA')}`;
  const code = `
async ( id ) => {
  if(!id){
    return;
  }

  // 调用get接口
  const { body } = await source.$requests.get(${params});

  // 处理接口的返回结果
  if (${codeString} !== 0) {
    $tips.error({
      content: ${messageString}
    })
    return body;
  }
  // data 就是查询到的数据
  const data = ${getEntityString};
  if(data){
    ${isForm ? `// 更新表单数据
    source.formData = data;` : ''}
  } else {
    $tips.error({
      content: 'get接口返回了空数据'
    })
  }
  return body;
}
`;
  return {
    args: [{
      id: 'id',
      title: '查询的主键值'
    }],
    code
  };
};
export function generateGetMethod(options) {
  const isForm = ['form_JS', 'rv_form_JS'].includes(options.stateModel);
  const config = selectConfig(options, getGetCode, isForm ? FORM_INFOS.form.get : FORM_INFOS.list.get);
  return {
    id: 'get',
    title: '获取',
    ...defaultMethodConfig,
    ...config,
    debugCode: invokeAndLogDebugCode
  };
}
const getDeleteCode = options => {
  const {
    collection,
    stateModel
  } = options;
  const params = getGetDeleteParams(options);
  const key = getEntityPrimaryKey(collection);
  const isForm = ['form_JS', 'rv_form_JS'].includes(stateModel);
  const {
    codeString,
    messageString
  } = options.getStringOfCodeMessage('delete');
  const removeCode = !isForm ? `
// 如果是复制数据就直接删除
if(!id){
  $utils.remove(source.listData, postData);
  return;
}
` : '';
  const code = `
async ( ${isForm ? '' : 'postData'}  ) => {

  // 获取主键
  const id = ${isForm ? 'source.formData' : 'postData'}['${key || '_id'}'];
  ${removeCode}
  // 调用delete接口
  const { body } = await source.$requests.delete(${params});

  // 处理接口的返回结果
  if (${codeString} === 0) {
    $tips.success({
      content: '删除成功'
    })
  } else {
    $tips.error({
      content: ${messageString}
    })
  }
  return body;
}
`;
  return {
    args: isForm ? [] : [{
      id: 'postData',
      title: '需要删除的数据'
    }],
    code
  };
};
export function generateDeleteMethod(options) {
  const isForm = ['form_JS', 'rv_form_JS'].includes(options.stateModel);
  const config = selectConfig(options, getDeleteCode, isForm ? FORM_INFOS.form.deleteConfig : FORM_INFOS.list.deleteConfig);
  return {
    id: 'delete',
    title: '删除',
    ...defaultMethodConfig,
    ...config,
    debugCode: invokeAndLogDebugCode
  };
}
//# sourceMappingURL=crud.js.map
